
import apiWorker from '../apiWorker'

const integration_logs =  {

    search : (data) => apiWorker('post',`/v1/admin/integration_logs/search`, data),

}

export default integration_logs;